import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import { fetchPartnerDetails } from "../../services/PartnerService";
import PartnerTeamsSection from "./PartnerTeamsSection";
import { usePartnerHasSoloUser } from "../../hooks/usePartnerHasSoloUser";

const Teams = () => {
  const authUser = useSelector((state) => state.auth.authUser);
  const partnerId = authUser?.partner_id;
  const navigate = useNavigate();

  const { hasSoloUser, isLoading: soloUserLoading } = usePartnerHasSoloUser(partnerId);

  useEffect(() => {
    if (!soloUserLoading && hasSoloUser) {
      navigate("/admin-details", { replace: true });
    }
  }, [hasSoloUser, soloUserLoading, navigate]);

  const { data: partnerDetailsData } = useQuery({
    queryKey: ["partnerDetails", partnerId],
    queryFn: () => fetchPartnerDetails(partnerId),
    enabled: !!partnerId && !hasSoloUser,
    staleTime: 5 * 60 * 1000,
  });

  const userPartnerDetails = partnerDetailsData?.data?.data ?? null;

  if (soloUserLoading || hasSoloUser) {
    return null;
  }

  return (
    <div className="row">
      <div className="col-12">
        <PartnerTeamsSection
          partnerId={partnerId}
          authUser={authUser}
          userPartnerDetails={userPartnerDetails}
          onAddExpenseTag={() => navigate("/admin-details#expense-tags")}
        />
      </div>
    </div>
  );
};

export default Teams;
